<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-spacer />
              <v-col
                cols="12"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="yearFilter"
                  clearable
                  :items="years"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>

              <v-col
                v-if="$hasPermissionTo(['copy eis'])"
                cols="12"
                md="2"
                xl="2"
              >
                <setup-payroll-setup-eis-dialog-copy
                  :available-years="years"
                  @created="handleDetailCopied"
                />
              </v-col>

              <v-col
                v-if="$hasPermissionTo(['create eis'])"
                cols="12"
                md="2"
                xl="2"
              >
                <setup-payroll-setup-eis-dialog-create
                  @created="loadEis"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          
          <v-data-table
            :headers="headers"
            :items="filteredEis"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.wages_from="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.wages_from) }}
                </span>
              </div>
            </template>

            <template v-slot:item.wages_to="{ item }">
              <div>
                <span>
                  {{ item.wages_to == '2147483647'? 'Infinity' :currencyFormatting(item.wages_to) }}  
                </span>
              </div>
            </template>

            <template v-slot:item.employer_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.employer_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.employee_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.employee_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.total="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.total) }}
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <setup-payroll-setup-eis-dialog-edit
                v-if="$hasPermissionTo(['update eis'])"
                :eis="item"
                @updated="loadEis"
              />
            </template> 
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPayrollSetupEisDialogCopy: () => import('@/components/payroll/setup/eis/DialogCopy'),
      SetupPayrollSetupEisDialogCreate: () => import('@/components/payroll/setup/eis/DialogCreate'),
      SetupPayrollSetupEisDialogEdit: () => import('@/components/payroll/setup/eis/DialogEdit'),
    },
  
    data () {
      return {
        tableLoading: false,
        yearFilter: (new Date()).getFullYear(),
        years: [],   
        search: '',
        eis: [],
        headers: [
          {
            text: 'From (RM)',
            align: 'right',
            value: 'wages_from',
            sortable: false,
          },
          {
            text: 'To (RM)',
            align: 'right',
            value: 'wages_to',
            sortable: false,
          },
          {
            text: 'Employer’s Contribution (RM)',
            align: 'right',
            value: 'employer_contribution',
            sortable: false,
          },
          {
            text: 'Employee’s Contribution (RM)',
            align: 'right',
            value: 'employee_contribution',
            sortable: false,
          },
          {
            text: 'Total (RM)',
            align: 'right',
            value: 'total',
            sortable: false,
          },
          {
            text: '',
            value: 'action',
            align: 'center',
          },
        ],
      }
    },
    computed: {
      filteredEis () {
        return this.eis.filter(eis => eis.year === this.yearFilter)
      },
    },
    created () {
      this.loadEis()
    },  
    methods: {     
      loadEis () {
        this.tableLoading = true

        Promise.all([
          this.$api.eis().listEisYear(),
          this.$api.eis().list(),
        ])
          .then(([year, eis]) => {
            this.years = year.data 
            this.eis = _.orderBy(eis.data, ['wages_from'], ['asc'])      

            this.tableLoading = false
          })
      },

      currencyFormatting (item) {
        return (Math.round((item / 100) * 100) / 100).toFixed(2)
      },

      handleDetailCopied (year) {
        this.setYearFilter(year)
        this.loadEis()
      },
      setYearFilter (year) {
        this.yearFilter = year
      },     
    },
  }
</script>
